<template>
<div>
    <section class="page-title" style="background-color:#c7eafb;">
    <div class="center">
      <v-layout row wrap>
        <v-flex xs12 sm12 lg8>
        <p class="label-planos">Convênio Plano Odontológico</p>
        <h1 class="the-title">Parceria</h1>   
        <h1 class="the-title" style="font-size:30px;color:#00358d">SINPRO RO - Sindicato dos Professores de Instituições de Ensino Superior Privadas do Estado de Rondônia</h1>
        </v-flex>  
        
        <v-flex xs12 sm12 lg4 style="text-align: right;" v-if="this.$vuetify.breakpoint.lg">  
            <br>
            <br>
            <br>
            <img src="../Content/images/SinproRO.png" width="300">
        </v-flex>
        <v-flex xs12 sm12 lg4 style="text-align: center;" v-else>  
            <img src="../Content/images/SinproRO.png" width="180">
        </v-flex>  
        <v-flex xs12 sm6 md6 lg6>
            <br>
            <v-btn
            style="border-radius: 6px;"
            large                
            dark
            @click="openDialog()"
            color="#00358d"
            >Cumprir a CCT
            </v-btn>
        </v-flex>       
        </v-layout>
    </div>
</section>

<section class="page-content center">
    <v-layout row wrap>    
    <v-flex xs12 sm12 lg10>
    <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/49.png" style="position: absolute;left: 90%;" width="150px">
    <img v-else src="../Content/images/49.png" width="150px">
    <p class="title-label">O seu sorriso é o nosso diferencial</p>
    <p>Informamos que já está em vigor A CONVENÇÃO COLETIVA DE TRABALHO 2021/2023 registrada junto ao Ministério do Trabalho e Emprego sob o nº de registro no MTE: RO000053/2021, número da solicitação: MR016549/2021.</p>
    <h1>CLÁUSULA DÉCIMA TERCEIRA - PLANO DE SAÚDE ODONTOLÓGICO</h1>
    <p>As IES assegurar um plano de saúde odontológico em benefício dos professores e seus demais dependentes observando o Inciso II;</p>
    <p>I - O valor mensal do desembolso das instituições, visando assegurar o PLANO DE SAÚDE ODONTOLÓGICO em benefício dos professores de administração efetivos ativos e seus dependentes, será de R$ 49,00 (quarenta e nove reais) por grupo familiar e deverá ser pago até o décimo dia do mês subsequente, observando o item IV;</p>
    <p>II - Consideram-se dependentes legais a(o) esposa(o) e/ou companheira(o) e filhos solteiros até 18 (dezoito) anos e filhas solteiras até 21 (vinte e um) anos;</p>
    <p>...</p>  
    <p style="font-weight: bold;">IV - Será descontado R$ 15,00 mensalmente em folha de pagamento do trabalhador beneficiado, auxiliar de administração. O restante será custeado pelas IES/Mantenedoras;</p>
    <p>...</p>
    <h1 style="font-weight: bold; font-size: 20px; color:#009b9b">SobreaPrimaVidaDental</h1>
    <p>A PrimaVida Dental é uma operadora exclusivamente odontológica, com 15 anos de mercado, com 260.000 beneficiários, mais de 8.000 pontos de atendimento em todo Brasil, devidamente registrada na Agência Nacional de Saúde Suplementar (ANS) sob o n.º 416525, possui processos de gestão inovadores, com tecnologia de ponta e modernidade, garantindo assim agilidade, segurança e a tranquilidade para os seus associados.</p>
    <h1 style="font-weight: bold; font-size: 20px; color:#009b9b">Benefícios</h1>
    <p>O Plano disponibilizado possui cobertura para todo o Rol de Procedimentos da ANS - Agência Nacional de Saúde Suplementar, com utilização imediata dos serviços, por não possuir carência contratual. Além de ampla rede credenciada com inúmeras opções de atendimento e especialidades</p>
    <p>Com o mais alto nível de informatização, permite também por aplicativo, onde na palma da mão, através de Smartphone ou Tablet, acesso à carteirinha virtual, rede credenciada, atendimento personalizado, tudo para uma fácil utilização, com um sistema diferenciado de atendimento via WhatsApp, para proporcionar conforto, com a certeza de bom atendimento e qualidade, tudo com muita transparência e respeito.</p>
    <!--<ul>Os Valores do plano contratado serão:</ul>
    <li style="font-weight: bold;">Funcionário (adesão obrigatória): R$ 17,90.</li>
    <li style="font-weight: bold;">Dependente (inclusão voluntária): R$17,90, com o valor integral descontado em folha.</li>
    <br> -->
    <v-flex xs5 sm5 lg12>
        <table cellpadding="0" cellspacing="0" border="1">
      <tr >
        <td style="color: #009b9b;">Plano: </td> 
        <td>&nbsp; SMILE 1000 RO </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Reg ANS nº: </td>
        <td>&nbsp; 485.127/20-7 </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Tipo de Contratação: </td>
        <td>&nbsp; COLETIVO EMPRESARIAL </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Formação de Preço: </td>
        <td>&nbsp; PRÉ-ESTABELECIDO </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Área de Abrangênia/Atuação: </td>
        <td>&nbsp; GRUPO DE MUNICÍPIOS RO </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Segmetação Assistencial: </td>
        <td>&nbsp; EXCLUSIVAMENTE ODONTOLÓGICA </td>
      </tr>
      <tr>
        <td style="color: #009b9b;">Carência: </td>
        <td>&nbsp; SEM CARÊNCIA </td>
      </tr>
    </table>
    </v-flex>
    <br>

    <p style="font-weight: bold; font-size: 20px; color:#009b9b">Aproveite já a oportunidade e garanta o sorriso dos seus colaboradores com a PrimaVida Dental.</p>    
    </v-flex>

    <v-flex xs12 sm12 lg12>
        <img src="../Content/images/logo.png" width="200">
    </v-flex>

    <v-flex xs12 sm12 lg7>
    <br>
    <p class="title-label">Acesso à rede credenciada</p>
    <p>Para acessar a rede credenciada, <a href="http://www.primavida.com.br/redecredenciada" target="_blank">clique aqui.</a></p>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Quem pode aderir ao Plano?</p>
    <li>Esposa(o) e/ou companheira(o)</li>
    <li>Filhos solteiros até 18 anos;</li>
    <li>Filhas solteiras até 21 anos.</li>
    <br>
    </v-flex>

    <v-flex xs12 sm12 lg6>
    <p class="title-label">Principais Vantagens</p>
    <li>Liberação on-line do seu plano de tratamento;</li>
    <li>O Beneficiário pode incluir familiares e agregados;</li>
    <li>Acesso a rede credenciada através do site www.primavida.com.br;</li>
    <li>Possibilidade de credenciamento de Dentistas por indicação do Associado;</li>
    <li>Desconto em medicamentos nas farmácias &nbsp;<img src="../Content/images/raia.jpg" width="60px"> &nbsp; <img src="../Content/images/drogasil.jpg" width="110px"></li>
    <li>Central de Atendimento exclusiva por Whatsapp;</li>
    <li>Aplicativo para Celular / Tablet com rede Credenciada;</li>
    <li>Carteirinha Virtual;</li>
    <li>Boleto Virtual;</li>
    <br>
    </v-flex>
    
    <v-flex xs12 sm12 lg12>
    <br>
    <p class="title-label" style="color:#212121;">App PrimaVida Beneficiário</p>    
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_android.png" width="120px"><br>
    <a href="https://play.google.com/store/apps/details?id=br.com.primavida.associado" target="_blank"><img src="../Content/images/android.png" width="120px"></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_apple.png" width="120px"><br>
    <a href="https://apps.apple.com/br/app/primavida-dental-associado/id1464690839" target="_blank"><img src="../Content/images/apple_stote.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg2>
    <img src="../Content/images/app_whats.png" width="120px"><br>
    <a href="https://api.whatsapp.com/send?phone=5521971640379" target="_blank"><img src="../Content/images/whatsapp.png" width="120px" ></a>&nbsp;
    </v-flex>
    <v-flex xs5 sm5 lg3>
    <img src="../Content/images/celular.png" width="130px"><br>    
    </v-flex>
    
    </v-layout>
    <br>
    <p class="title-label">Principais Coberturas (Rol da ANS)</p>
    <div class="icone consultas">
        <span class="icon"></span>
        <p><strong>Consultas</strong> - Consultas iniciais para o plano de tratamento;</p>
    </div>
    <div class="icone urgencia">
        <span class="icon"></span>
        <p><strong>Urgência</strong> - Diversos procedimentos de urgência odontológica;</p>
    </div>
    <div class="icone cirurgia">
        <span class="icon"></span>
        <p><strong>Cirurgia</strong> - Cirurgias odontológicas de pequeno porte realizada em consultórios;</p>
    </div>
    <div class="icone dentistica">
        <span class="icon"></span>
        <p><strong>Dentística</strong> - Restaurações e obturações em material estético (Resina) e amálgama;</p>
    </div>
    <div class="icone endodontia">
        <span class="icon"></span>
        <p><strong>Endodontia</strong> - Tratamento de canais;</p>
    </div>
    <div class="icone periodontia">
        <span class="icon"></span>
        <p><strong>Periodontia</strong> - Tratamento de gengivas;</p>
    </div>
    <div class="icone odontopediatria">
        <span class="icon"></span>
        <p><strong>Odontopediatria</strong> - Atendimento especializado para crianças;</p>
    </div>
    <div class="icone radiologia">
        <span class="icon"></span>
        <p><strong>Raio X</strong> - Periapical, interproximal (bite-wing), oclusal, periapical completa (levantamento radiográfico);</p>
    </div>
    <div class="icone protese">
        <span class="icon"></span>
        <p><strong>Próteses</strong> - Coroa provisória, Restauração, Coroa, Núcleo e Bloco metálico para dentes permanentes posteriores, Coroa em Cerômero para dentes permanentes anteriores (Entende-se como dentes permanentes anteriores, os dentes definitivos da frente, que correspondem do canino a canino);</p>
    </div>
    <div class="icone profilaxia">
        <span class="icon"></span>
        <p><strong>Prevenção</strong> - Profilaxia / Aplicação de Flúor;</p>
    </div>
    <div class="icone exodontia">
        <span class="icon"></span>
        <p><strong>Exodontia</strong> - Extração, inclusive de siso incluso;</p>
    </div>
    <div>
        <p>Para acessar a cobertura do Rol da ANS, <a href="http://www.primavida.com.br/emkt/rol_procedimentos.pdf" target="_blank">clique aqui.</a></p>
    </div>
    <v-flex xs12 sm6 md6 lg12 >
        <v-btn style="border-radius: 6px; width: 200px" large dark @click="openDialog()" color="#00358d">Cumprir a CCT</v-btn>
        <br>
        <v-btn style="border-radius: 6px; width: 200px" large dark href="https://ecommerce.primavida.com.br/contratos/SINPRO/FICHA_DE_ADESAO_COLETIVO_POR_ADESAO_SINPRO.pdf" target="_blank" color="#00358d">Ficha de Adesão</v-btn>
        <br>
        <v-btn style="border-radius: 6px; width: 200px" large dark href="https://wa.me/552132994501?text=Olá,%20pode%20me%20ajudar?" target="_blank" color="#00358d">Fale Conosco</v-btn>
        <br>
        <v-btn style="border-radius: 6px; width: 200px" large dark href="https://www.primavida.com.br/emkt/planilha_carga.xlsx" target="_blank" color="#00358d">Planilha de Carga</v-btn>
        <br v-if="!this.$vuetify.breakpoint.lg">
        <br v-if="!this.$vuetify.breakpoint.lg">
        <img v-if="this.$vuetify.breakpoint.lg" src="../Content/images/logo-ans.png" width="200" style="float:right;">
        <img v-if="!this.$vuetify.breakpoint.lg" src="../Content/images/logo-ans.png" width="200">
    </v-flex>
</section>
<v-dialog v-model="dialog" max-width="700px" max-height="400px"> 
      <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
              <span class="total">Prezado(a) parceiro(a),</span>              
              </v-card-title>
              <v-container                    
                    fluid
                    pa-1
                    justify-center
                    class="resumo"
                  >
              <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a  segurança e a tranquilidade que você precisa.</p>
              <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
              <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
              <br>
              <p class="resumo" style="font-weight: bold">A <span style="color:#009B99">PrimaVida Dental</span> agradece a sua atenção !</p>
              <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!!!</p>
              <br>
              <p class="resumo" style="font-weight: bold;color:#009B99">Termo de Privacidade, <a href="https://ecommerce.primavida.com.br/contratos/Politica_de_Privacidade_PrimaVida_LGPD.pdf" target="_blank">clique aqui.</a></p>
              
              <v-checkbox
                    v-model="contrataccept"
                    color="#009B99"
                >
                <span slot="label">Estou ciente e concordo com o Termo de Privacidade da PrimaVida Dental.</span>
          </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container
                    fill-height
                    fluid
                    pa-1
                    justify-center
                  >
                  <br>
              <v-btn :disabled="!contrataccept" color="#009b9b" depressed style="border-radius: 8px; width: 130px;color: white;" :href="'https://ecommerce.primavida.com.br/contratopj?plano=63ea6600dd057e1bd9969ee0'">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
      </v-card>
    </v-dialog>
<Snackbar ref=chamaSnackbar />
</div>
</template>
<script>
import Snackbar from '../components/snackbar.vue'
export default {
    components: {Snackbar},
     data(){
        return{   
                contrataccept: false,
                dialog: false,
                matricula: '',
                dictionary: {          
                custom: {               
                carteirinha: {
                  required: () => 'Informe o número da carteirinha'
                } 
                }
                }
        }               
    },

    mounted : function(){
        this.$store.dispatch('EscondeToolbar')
        this.$store.dispatch('EscondeFooter')
        this.$validator.localize('pt', this.dictionary)
        localStorage.clear()
        sessionStorage.clear()

    },
     watch: {
        dialog(val) {
        val || this.close()
      }
     },
    methods: {
        openDialog(){
            this.dialog = true
        }
        
    }

}
</script>

<style>

    .link{
        font-size: 1.3rem;
        color: #194383;
        text-align: center;
    }
    .titulo{
        font-size: 2rem;
        color: #797a7a;
        text-align: center;
    }
    .tabela{
        border-collapse: separate;
        border-spacing: 2;
    }
</style>